/**
 * @flow
 * @format
 */

import _DesignToolBar from './DesignToolBar';

export default _DesignToolBar;



// WEBPACK FOOTER //
// ./src/components/DesignToolBar/index.js